<template>
  <div class="locale-changer">
    <select class="custom-select" v-model="$i18n.locale">
      <option value="es">Español</option>
      <option value="en">English</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "locale-changer",
  watch: {
    ["$i18n.locale"]() {
      const locale = this.locale;
      const to = this.$router.resolve({ params: { locale } });
      //console.log(to.location);
      this.$router.push(to.location);
    },
  },
};
</script>
